const config = {
  options: [
    {
      languageId: "english",
      locale: "en-US",
      text: "English",
    },

    {
      languageId: "spanish",
      locale: "es-ES",
      text: "Spanish",
    },

    {
      languageId: "portuguese",
      locale: "pt-BR",
      text: "Português",
    },
  ],
};

export function getCurrentLanguage(lang) {
  let selectedLanguage =
    JSON.parse(localStorage.getItem("lang")) || config.options[0];
  config.options.forEach((language) => {
    if (language.languageId === lang) {
      localStorage.setItem("lang", JSON.stringify(language));
      selectedLanguage = language;
    }
  });
  return selectedLanguage;
}
export default config;
